// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/distress-signal-assistance-duty.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/distress-signal-assistance-duty/distress-assistance-duty.js';
import g1 from '../lessons/air-law/distress-signal-assistance-duty/distress-signal-assistance-duty.js';

mount([g0, g1]);
